export type Platform = 'x' | 'instagram' | 'facebook' | 'linkedin' | 'tiktok' | 'youtube' | 'gmb';

export const PLATFORMS: Record<
  Platform,
  { label: string; color: string; textColor: string; charLimit: number; icon: string }
> = {
  x: {
    label: 'X (Twitter)',
    color: '#000000',
    textColor: '#ffffff',
    charLimit: 280,
    icon: 'x',
  },
  instagram: {
    label: 'Instagram',
    color: '#E1306C',
    textColor: '#ffffff',
    charLimit: 2200,
    icon: 'instagram',
  },
  facebook: {
    label: 'Facebook',
    color: '#1877F2',
    textColor: '#ffffff',
    charLimit: 63206,
    icon: 'facebook',
  },
  linkedin: {
    label: 'LinkedIn',
    color: '#0A66C2',
    textColor: '#ffffff',
    charLimit: 3000,
    icon: 'linkedin',
  },
  tiktok: {
    label: 'TikTok',
    color: '#010101',
    textColor: '#ffffff',
    charLimit: 2200,
    icon: 'tiktok',
  },
  youtube: {
    label: 'YouTube',
    color: '#FF0000',
    textColor: '#ffffff',
    charLimit: 5000,
    icon: 'youtube',
  },
  gmb: {
    label: 'Google Business',
    color: '#4285F4',
    textColor: '#ffffff',
    charLimit: 1500,
    icon: 'map-pin',
  },
};

export const PLATFORM_LIST = Object.entries(PLATFORMS).map(([id, data]) => ({
  id: id as Platform,
  ...data,
}));
